const NEW_COMP_APPROVAL = 'NEW_COMP_APPROVAL';
const GET_COMP_APPROVAL_LINKS = 'GET_COMP_APPROVAL_LINKS';
const REMOVE_DATA = 'REMOVE_DATA';
const SET_DATA = 'SET_DATA';
const SET_LINK = 'SET_LINK';
const SET_COMPETITION = 'SET_COMPETITION';
const REMOVE_COMPETITION = 'REMOVE_COMPETITION';
const GET_COMP_BY_ID = 'GET_COMP_BY_ID';
const UPDATE_COMP_APPROVAL = 'UPDATE_COMP_APPROVAL';
const GET_COMP_APPROVAL_LIST = 'GET_COMP_APPROVAL_LIST';
const GET_COMP_APPROVAL_DETAIL = 'GET_COMP_APPROVAL_DETAIL';
const SET_COMPETITIONS = 'SET_COMPETITIONS';
const FETCH_COMP_APPROVAL_LIST = 'FETCH_COMP_APPROVAL_LIST';
const GET_COMPETITION_BY_GUID = 'GET_COMPETITION_BY_GUID';
const ENRICH_COMPETITION = 'ENRICH_COMPETITION';
const REQUEST_COMP_APPROVAL = 'REQUEST_COMP_APPROVAL';
const SEND_ATTACHMENT = 'SEND_ATTACHMENT';
const SEND_APPROVAL_UPDATE = 'SEND_APPROVAL_UPDATE';
const SEND_APPROVAL_CANCELLATION = 'SEND_APPROVAL_CANCELLATION';
const SEND_FINISHER = 'SEND_FINISHER';
const COPY_COMP_APPROVAL = 'COPY_COMP_APPROVAL';
const DELETE_ATTACHEMENT = 'DELETE_ATTACHEMENT';
const DELETE_COMPETITION = 'DELETE_COMPETITION';
const CREATE_RECEIPT = 'CREATE_RECEIPT';

export default {
	GET_COMP_APPROVAL_LINKS,
	NEW_COMP_APPROVAL,
	REMOVE_DATA,
	SET_DATA,
	SET_LINK,
	SET_COMPETITION,
	REMOVE_COMPETITION,
	GET_COMP_BY_ID,
	UPDATE_COMP_APPROVAL,
	GET_COMP_APPROVAL_LIST,
	GET_COMP_APPROVAL_DETAIL,
	SET_COMPETITIONS,
	FETCH_COMP_APPROVAL_LIST,
	GET_COMPETITION_BY_GUID,
	ENRICH_COMPETITION,
	REQUEST_COMP_APPROVAL,
	SEND_ATTACHMENT,
	SEND_APPROVAL_UPDATE,
	SEND_APPROVAL_CANCELLATION,
	SEND_FINISHER,
	COPY_COMP_APPROVAL,
	DELETE_ATTACHEMENT,
	DELETE_COMPETITION,
	CREATE_RECEIPT,
};
